import resume from '../assets/pdf/resume.pdf'
import profile from '../assets/png/profile.jpg'

export const headerData = {
    name: 'Shadrack Koech',
    title: 'Software Engineer',
    description: 'Software Engineer with 5+ years of experience building scalable backend systems, RESTful APIs, and data-driven applications. Proven track record designing agentic AI environments, leading engineering teams, and delivering enterprise-grade solutions across logistics, fintech, and AI infrastructure.',
    image: profile,
    resumePdf: resume
}
